import React from 'react'
import {Link} from 'react-router-dom'
import Slider from 'react-slick'
import ReactGA from 'react-ga';


import NextArrowIcon from'../../../public/assets/img/chevron-right-solid.svg'
import PreviousArrowIcon from '../../../public/assets/img/chevron-left-solid.svg'

function initializeGA(){
    ReactGA.initialize('UA-144557614-1');
    ReactGA.pageview('/home-content')
  }

function interaction(){
	ReactGA.event({
		category: 'carousel',
		action: 'click', 

	});
}

function NextArrow(props){
    const {className, style, onClick } = props;
    return(
        <div className={className} style={{...style, display: "block"}}  onClick={onClick}>
            <img src={NextArrowIcon} className="slick-next" style={{height: "60px"}} alt="próximo slide"/>
        </div>
    );
}

function PrevArrow(props){
    const {className, style, onClick } = props;
    return(
        <div className={className} style={{...style, display: "block"}} onClick={onClick}>
            <img src={PreviousArrowIcon} className="slick-prev" style={{height: "60px"}} alt="slide anterior" />
        </div>
    );
}

const CreateCard = ({name, title, summary, image_url, image_alt, neighborhood, city, params, price}) => {
    return(<div>
        <div className="card">
            
        <Link to={{pathname: "/imoveis/" + name, state:{params}}} style={{color: "inherit"}} onClick={interaction()}>

        <img className="card-img-top" src={image_url} alt={image_alt} />
        <div className="card-body" style={{height: "22rem"}}>
            <h2 className="card-title" style={{ marginBottom: "0"}}>{title}</h2>
            <p className="card-subtitle" >{neighborhood}, {city}</p>
            <br />

            <p className="card-text">{summary}</p>

            <div className="text-center">
                <p style={{ marginBottom: "0"}}>a partir de: </p>
                <p style={{ marginBottom: "0"}}><b>{price}</b></p>
            </div>
        </div>
        </Link>

        <div className="card-footer" style={{textAlign: "center"}}>
        <Link to={{pathname: "/imoveis/" + name, state:{params}}} className="btn btn-primary" onClick={interaction()}>Veja detalhes</Link>
        </div>
        </div>
        </div>);

}

export default class Article extends React.Component {


    constructor(props){
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.data = this.props.data;
    }

    next() {
        this.slider.slickNext(); 
    }

    previous() {
        this.slider.slickPrev();
    }

    componentDidMount(){
        initializeGA();
    }

    render() {
      
        const settings = {
            accessibility: true,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 7000,
            pauseOnHover: true,
            speed: 500, 
            slidesToShow: 3,
            slidesToScroll:1,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            responsive: [
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                  }
                }, 
                {
                    breakpoint: 800,
                    settings: {
                      slidesToShow: 2,

                    }
                }
            ]

        };

        return( 
            <div className="container" style={{width: "75%"}}>

                <div>
                    <br />
                    <h2>Imóveis à venda</h2>
                    <br />
                </div>

                <Slider ref={c => (this.slider = c)}{...settings}>
                    {this.data.map((obj) => <CreateCard key={obj.id} name={obj.name} title={obj.title} summary={obj.summary} image_url={obj.image_url} image_alt={obj.image_alt} neighborhood={obj.neighborhood} city={obj.city} params={obj} price={obj.price}/>)}                                        
                </Slider>
            </div>
        );

    };
};




// WEBPACK FOOTER //
// ./src/common/Article/index.jsx